import * as shallowEqual from "fbjs/lib/shallowEqual";
export { shallowEqual };
export default shallowEqual;

//# sourceMappingURL=shallowEqual.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/shallowEqual.js
// module id = 12
// module chunks = 0